export function getCurrentMoonPhase(): number {
  const newMoonRef = new Date(2020, 7, 18, 7, 42, 15);
  const today = new Date();
  const dayInMilliseconds = 1000 * 3600 * 24;

  return Math.round(
    ((today.getTime() - newMoonRef.getTime()) / dayInMilliseconds) % 29.53
  );
}

export function padNumber(num: number): string {
  return (num < 10) ? ('0' + num) : num.toString();
}

export function getPdfViewZoomLevel(): number {
  return window.innerWidth > 836
    ? 1
    : (window.innerWidth - 4) / 836;
}
